import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RingLoader } from 'react-spinners';

import { isVisible } from '@selectors/loadingModal';

import './LoadingModal.scss';

const LoadingModal = ({ isVisible }) => isVisible && (
  <div className="loading-modal">
    <div className="loading-modal__overlay">
      <div className="loading-modal__spinner">
        <RingLoader
          color="#26c6da"
          size={100}
        />
      </div>
      <div className="loading-modal__text">
        <div className="loading-modal__title">
          Loading
        </div>
        <div className="loading-modal__subtitle">
          Please wait...
        </div>
      </div>
    </div>
  </div>
);

LoadingModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isVisible: isVisible(state),
});

export default connect(mapStateToProps)(LoadingModal);



// WEBPACK FOOTER //
// ./src/routes/containers/LoadingModal/LoadingModal.js